<template>
  <div class="select select--input">
    <div class="dropdown dropdown--full-width">
      <Popper placement="bottom-end" v-model:open="open">
        <template #trigger>
          <div class="dropdown__trigger" @click="open = !open">
            <div class="select__trigger">
              <span class="select__label select__label--flex select__label--flat">
                <template v-if="modelValue">
                  <template v-if="modelValue.isNew">
                    <span class="menu-item__label-icon">
                      <UseSvg name="plus" class="icon icon--small" />
                    </span>
                    <span class="menu-item__label">
                      {{ $t('shafts.group.new_group') }}
                    </span>
                  </template>
                  <span v-else>{{ modelValue.name }}</span>
                </template>
                <span v-else class="dim">{{ $t('shafts.group.no_group') }}</span>
              </span>

              <span class="select__arrow">
                <UseSvg name="arrow_down_16" class="icon icon--small" />
              </span>
            </div>
          </div>
        </template>

        <div class="menu menu--dropdown">
          <ul class="menu__items">
            <li class="menu-item menu-item--dropdown">
              <button class="menu-item__link" @click="selectGroup(null)">
                <span class="menu-item__label dim">
                  {{ $t('shafts.group.no_group') }}
                </span>
              </button>
            </li>
            <li
              class="menu-item menu-item--dropdown"
              v-for="group in groups"
              :key="group.id"
            >
              <button class="menu-item__link" @click="selectGroup(group)">
                <span class="menu-item__label">
                  {{ group.name }}
                </span>
              </button>
            </li>
          </ul>
        </div>
      </Popper>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import Popper from '@/components/generic/popper.vue';
import UseSvg from '@/components/generic/use_svg.vue';

defineProps({
  modelValue: { type: Object, default: null },
  groups: { type: Array, default: () => [] },
});
const emit = defineEmits(['update:modelValue']);

const open = ref(false);

function selectGroup(group) {
  emit('update:modelValue', group);
  open.value = false;
}
</script>
